import { observer } from "mobx-react-lite";
import { context } from "..";
import Logo from "../misc/Logo";
import { Button } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import React from "react";
import { Icons } from "../misc/Icons";


export default observer(function Header () {

    var params = useParams()
    var navigate = useNavigate()

    React.useEffect(() => {
        context.getAdvisorAccount(params.advisorUid).catch((response) => {
            navigate("/")
        })
    }, [])

    if (!context.advisorAccount) return <header style={{boxShadow: "none"}}></header>

    if (context.template && context.embedded) {
        return <HeaderButtons />
    }

    return (
        <header>
            <div className="main-inner" style={{gap: "25px", flexFlow: "wrap"}}>
                {context.advisorAccount.logoUri 
                    ? <img src={context.advisorAccount.logoUri} alt="logo" height="40" />
                    : <Logo width={100} type="block" />}

                {context.template ? (
                    <HeaderButtons />
                ) : null}
            </div>
        </header>
    )
})


const HeaderButtons = observer(() => {
    
    const { showPreviousAnswers, showSettings, togglePreviousAnswers, toggleSettings, logout, backPage, pageIndex, getSubmittedPages, embedded, answers, template } = context
    const submittedPages = getSubmittedPages()

    return (
        <div style={{display: "flex", gap: "20px", flexFlow: "wrap"}}>
            {showPreviousAnswers || showSettings ? (
                <Button
                    className="btn btn-sm"
                    variant="contained"
                    color="success"
                    onClick={() => {
                        togglePreviousAnswers(false)
                        toggleSettings(false)
                    }}>
                    <b>Back to questionnaire</b>
                </Button>
            ) : (
                <>
                    <Button
                        disabled={pageIndex === 0 || submittedPages?.length < 1 || showPreviousAnswers}
                        className="btn btn-sm"
                        variant="contained"
                        color="secondary"
                        onClick={() => backPage()}>
                        <Icons.DoubleArrow style={{transform: "rotate(180deg)"}} /><b>Go back</b>
                    </Button>

                    <Button
                        className="btn btn-sm"
                        variant="contained"
                        color="secondary"
                        disabled={context.submitting}
                        onClick={() => context.saveAndQuit()}>
                        <Icons.Exit /><b>Save and Quit</b>
                    </Button>

                    {template.settings ? (
                        <Button
                            disabled={answers["settings_confirmed"] !== "true"}
                            className="btn btn-md link"
                            color="info"
                            // variant="contained"
                            onClick={() => toggleSettings()}>
                            Settings
                        </Button>
                    ) : null}

                    {submittedPages.length ? (
                        <Button
                            className="btn btn-md link"
                            color="info"
                            // variant="contained"
                            onClick={() => togglePreviousAnswers()}>
                            All answers
                        </Button>
                    ) : null}
                </>
            )}

            {embedded ? (
                <Button
                    className="btn btn-sm"
                    // variant="contained"
                    color="info"
                    onClick={() => logout()}>
                    Log out
                </Button>
            ) : null}
        </div>
    )
})